import '../timeline/components/resources_box';
import '../xray/components/meet';
import './components/activity/index.scss';
import './components/activity_comment/index.scss';
import './components/activity_reply/index.scss';
import './components/cta';
import './components/new_activity';
import './components/sidebar_box';
import './components/timeline_filter';
import './components/timeline_loader';
import 'components/campaigns/interventions/square_banner';
import 'components/cms/render_component';
import 'components/empty_list_message';
import 'components/practice_test_banner';
import Timeline from './lib/timeline';
import validator from 'utils/validator';

(function () {
  'use strict';
  validator.init();
  new Timeline().start();
})();
